import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  solid,
  regular,
  brands,
} from "@fortawesome/fontawesome-svg-core/import.macro";
import ContentCard from "./ContentCard";
import products from "../services/data/product";
import MainLayout from "./MainLayout";
import categories from "../services/data/categories";

const HomeLayout = () => {
  // const categories = [];
  // products.map((item, index) => {
  //   if (categories.indexOf(item.category) === -1) {
  //     categories.push(item.category);
  //   }
  // });

  const [product, setProduct] = useState(products);
  const [categorySelectedPoint, setCategorySecelectedPoint] = useState("all");

  const handleCategories = (e) => {
    const categorySelected = e.target.id;
    setCategorySecelectedPoint(categorySelected);
    if (categorySelected === "all") {
      setProduct(products);
    } else {
      const productByCategory = products.filter(
        (item, index) => item.category === categorySelected
      );
      setProduct(productByCategory);
    }
  };

  const handleOrder = (e) => {
    const orderBySelected = e.target.value;
    console.log(orderBySelected);

    if (orderBySelected === "termurah") {
      const orderProduct = product.sort(
        (a, b) => a.originalPrice - b.originalPrice
      );
      console.log(orderProduct);
      setProduct(orderProduct);
    }
  };
  return (
    <MainLayout>
      <div className="flex max-w-7xl mx-auto">
        <div className="h-auto w-[25%] hidden sm:block xl:w-80 px-3">
          <div className="my-14">
            <h1 className="font-bold text-lg pb-2">Categories</h1>

            {categories.map((item, index) => {
              return (
                <div
                  className={`flex justify-between p-0.5 mb-2 rounded-xl ${
                    item === categorySelectedPoint ? "bg-[#F9F9F9]" : ""
                  }`}
                >
                  <button onClick={(e) => handleCategories(e)} id={item}>
                    {item}
                  </button>
                  <div className="w-8 h-5 bg-[#F4F8EC] rounded-full flex justify-center items-center">
                    <span className="font-extrabold text-xs text-[#6A983C]">
                      {
                        products.filter(
                          (product, productIndex) => product.category === item
                        ).length
                      }
                    </span>
                  </div>
                </div>
              );
            })}

            <div
              className={`flex justify-between p-0.5 rounded-xl ${
                "all" === categorySelectedPoint ? "bg-[#F9F9F9]" : ""
              }`}
            >
              <button onClick={(e) => handleCategories(e)} id="all">
                All
              </button>
              <div className="w-8 h-5 bg-[#F4F8EC] rounded-full flex justify-center items-center">
                <span className="font-extrabold text-xs text-[#6A983C]">
                  {products.length}
                </span>
              </div>
            </div>
          </div>
          <div className="my-14">
            <h1 className="font-bold text-lg pb-2">Order By</h1>
            <div>
              <div>
                <input
                  type="radio"
                  id="abjad"
                  name="diradio"
                  value="abjad"
                  onChange={(e) => handleOrder(e)}
                />
                  <label for="html">Urutkan A - Z</label>
              </div>
              <div>
                <input
                  type="radio"
                  id="termahal"
                  name="diradio"
                  value="termahal"
                  onChange={(e) => handleOrder(e)}
                />
                  <label for="html">Termahal</label>
              </div>
              <div>
                <input
                  type="radio"
                  id="termurah"
                  name="diradio"
                  value="termurah"
                  onChange={(e) => handleOrder(e)}
                />
                  <label for="html">Termurah</label>
              </div>
            </div>
          </div>
          <div className="my-14">
            <h1 className="font-bold text-lg pb-2">Rating</h1>
            <div>
              <input type="checkbox" />
              &nbsp;&nbsp;
              <FontAwesomeIcon icon={solid("star")} color="#FDBC15" />
              <FontAwesomeIcon icon={solid("star")} color="#FDBC15" />
              <FontAwesomeIcon icon={solid("star")} color="#FDBC15" />
              <FontAwesomeIcon icon={solid("star")} color="#FDBC15" />
              <FontAwesomeIcon icon={solid("star")} color="#FDBC15" />
            </div>
            <div>
              <input type="checkbox" />
              &nbsp;&nbsp;
              <FontAwesomeIcon icon={solid("star")} color="#FDBC15" />
              <FontAwesomeIcon icon={solid("star")} color="#FDBC15" />
              <FontAwesomeIcon icon={solid("star")} color="#FDBC15" />
              <FontAwesomeIcon icon={solid("star")} color="#FDBC15" />
              {/* <FontAwesomeIcon icon={regular("star")} /> */}
            </div>
            <div>
              <input type="checkbox" />
              &nbsp;&nbsp;
              <FontAwesomeIcon icon={solid("star")} color="#FDBC15" />
              <FontAwesomeIcon icon={solid("star")} color="#FDBC15" />
              <FontAwesomeIcon icon={solid("star")} color="#FDBC15" />
              {/* <FontAwesomeIcon icon={solid("star")} color="#FDBC15" /> */}
              {/* <FontAwesomeIcon icon={regular("star")} /> */}
            </div>
            <div>
              <input type="checkbox" />
              &nbsp;&nbsp;
              <FontAwesomeIcon icon={solid("star")} color="#FDBC15" />
              <FontAwesomeIcon icon={solid("star")} color="#FDBC15" />
              {/* <FontAwesomeIcon icon={solid("star")} color="#FDBC15" /> */}
              {/* <FontAwesomeIcon icon={solid("star")} color="#FDBC15" /> */}
              {/* <FontAwesomeIcon icon={regular("star")} /> */}
            </div>
            <div>
              <input type="checkbox" />
              &nbsp;&nbsp;
              <FontAwesomeIcon icon={solid("star")} color="#FDBC15" />
              {/* <FontAwesomeIcon icon={solid("star")} color="#FDBC15" /> */}
              {/* <FontAwesomeIcon icon={solid("star")} color="#FDBC15" /> */}
              {/* <FontAwesomeIcon icon={solid("star")} color="#FDBC15" /> */}
              {/* <FontAwesomeIcon icon={regular("star")} /> */}
            </div>
          </div>
          <div className="mt-14">
            <h1 className="font-bold text-lg pb-2">Price</h1>
            <div className="w-full mb-3">
              <input type="range" className="accent-[#6A983C] w-full" />
            </div>
            <div className="flex">
              <div className="mx-5">
                <h1>Min</h1>
                <input
                  type="text"
                  value="0"
                  disabled
                  className="mt-1 w-full px-3 py-2 bg-white border border-slate-300 rounded-md text-sm shadow-sm placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none "
                />
              </div>
              <div className="mx-5">
                <h1>Max</h1>
                <input
                  type="text"
                  value="0"
                  disabled
                  className="mt-1 w-full px-3 py-2 bg-white border border-slate-300 rounded-md text-sm shadow-sm placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none "
                />
              </div>
            </div>
          </div>
          <div className="mt-10">
            <div className="flex justify-evenly">
              <button className="text-center w-1/3 text-base pt-2 font-bold rounded-2xl w-21 h-12 text-white bg-[#6A983C] border-solid border-[#46760A] p-3 hover:bg-[#598033] hover:shadow-lg focus:bg-[#4a692a] focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-200 active:shadow-lg transition duration-150 ease-in-out">
                Apply
              </button>
              <button className="text-center w-1/3 text-lg pt-2 font-bold rounded-2xl w-21 h-12 text-[#A9A9A9]  p-3">
                Reset
              </button>
            </div>
          </div>
        </div>

        <div className="w-full sm:ml-auto sm:w-[75%] grid grid-cols-2 sm:grid-cols-3 gap-4 p-5 sm:p-14">
          {product.map((item, index) => {
            return <ContentCard item={item} key={index} />;
          })}
        </div>
      </div>
    </MainLayout>
  );
};

export default HomeLayout;
